import { EnterpriseNoticeAcceptanceLogsV1NaptimeResource } from './__generated__/EnterpriseNoticeAcceptanceLogsV1';

class EnterpriseNoticeAcceptanceLog extends EnterpriseNoticeAcceptanceLogsV1NaptimeResource {
  static RESOURCE_NAME = 'enterpriseNoticeAcceptanceLogs.v1' as const;
}

export default EnterpriseNoticeAcceptanceLog;
